module.exports = __webpack_public_path__ + "static/fonts/fons_2.f983acb.otf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/fons_2.otf
// module id = Y/2f
// module chunks = 1